import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export function AuthLoadingFallback() {
  return (
    <Stack
      component="main"
      role="status"
      aria-live="polite"
      spacing={2}
      sx={{
        minHeight: "100dvh",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
      }}
    >
      <CircularProgress aria-hidden="true" />
      <Typography>Checking your account…</Typography>
    </Stack>
  );
}
